// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3qB7O","paramInput":"JobSimulator_paramInput__1ZlD1","input":"JobSimulator_input__27iqe"};